module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.has(_vm.name)
    }
  }, [_c('div', {
    staticClass: "has-float-label"
  }, [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validation),
      expression: "validation"
    }],
    ref: _vm.name,
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": _vm.name,
      "name": _vm.name,
      "placeholder": _vm.placeholder ? _vm.placeholder : _vm.label,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.errors.has(_vm.name)) ? _c('div', {
    staticClass: "form-control-feedback"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.name)))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64a465b3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Form/FormTextArea.vue
// module id = 635
// module chunks = 1